module.exports = __webpack_public_path__ + "static/img/cp_banner.7111df7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/cp_banner.png
// module id = SkUe
// module chunks = 1